import { css } from '@emotion/css'
import React from 'react'
import { PrimaryApplicationIndicator } from '../../../components/primary-application'
import { createNgReactBridgeDirective } from '../../react-bridge'

interface ReactPrimaryApplicationIconProps {
  moduleCount: number
}

function ReactPrimaryApplicationIcon(props: ReactPrimaryApplicationIconProps) {
  if (props.moduleCount === undefined) {
    throw new Error('moduleCount prop is required')
  }

  return (
    <PrimaryApplicationIndicator
      containerClassName={css`
        width: min-content;
      `}
      {...props}
    />
  )
}

export const reactPrimaryApplicationIcon = createNgReactBridgeDirective(
  'reactPrimaryApplicationIcon',
  [],
  ReactPrimaryApplicationIcon,
  ['organizationID', 'primaryApplication', 'moduleCount', 'refresh']
)
